import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './Dots.scss';
const Dots = ({ pageSize, totalPages, onChangePage, getPageUrl, startOpen = false })=>{
    const { t } = useTranslation();
    const logBiEvent = useBiLogger();
    const [showPopover, setShowPopover] = useState(startOpen);
    const [pageNumber, setPageNumber] = useState();
    const isValidPage = !!pageNumber && pageNumber > 0 && pageNumber <= totalPages;
    const onInputChange = (ev)=>{
        const value = ev.target.value;
        if (value === '' || value === undefined) {
            setPageNumber(undefined);
            return;
        }
        const number = parseInt(value, 10);
        if (!Number.isNaN(number)) {
            setPageNumber(number);
        }
    };
    const closePopover = useCallback(()=>setShowPopover(false), []);
    const onKeyDown = useCallback((e)=>{
        if (e.key === 'Enter') {
            setShowPopover(false);
            onChangePage && onChangePage(pageNumber);
            if (getPageUrl) {
                const url = getPageUrl(pageNumber);
                if (url) {
                    logBiEvent(BiData({
                        evid: 113,
                        direction: `${pageNumber}`,
                        thumbs_per_page: pageSize
                    }));
                    window.location.assign(url);
                }
            }
        }
    }, [
        getPageUrl,
        onChangePage,
        pageNumber,
        pageSize,
        logBiEvent
    ]);
    return /*#__PURE__*/ React.createElement(SimplePopperPopover, {
        className: s['wrapper'],
        isVisible: showPopover,
        contentClassName: s['jump-panel'],
        showArrow: false,
        placement: "bottom",
        onClickOutside: closePopover,
        popoverContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: s['goto']
        }, t('pagination.goToPage')), /*#__PURE__*/ React.createElement(TextInput, {
            id: "pagination-goto-page-input",
            value: pageNumber ? `${pageNumber}` : '',
            onChange: onInputChange,
            onKeyDown: isValidPage ? onKeyDown : undefined,
            className: s['input'],
            label: t('pagination.goToPage'),
            isLabelHidden: true,
            autoFocus: true
        }))
    }, /*#__PURE__*/ React.createElement("button", {
        className: classnames(s['dots'], showPopover && s['open']),
        onClick: ()=>setShowPopover((show)=>!show)
    }, "..."));
};
Dots.displayName = 'Dots';
export default Dots;

//# sourceMappingURL=Dots.js.map